// Ported verbatim from https://voiceorbs.vercel.app/orbs/particles-orb (`src/registry/lib/use-in-view.ts`)
// -- see orb-state.ts's header comment for provenance. Pauses the orb's rAF loop when it's
// scrolled off-screen or the tab is hidden, so a voice_orb Assistant left open in a background tab
// doesn't keep redrawing 720 particles a frame for nothing.
"use client";
import { useEffect, useRef } from "react";
export const observeActivity = (el, onChange) => {
    let inView = true;
    let pageVisible = document.visibilityState === "visible";
    let active = inView && pageVisible;
    const sync = () => {
        const next = inView && pageVisible;
        if (next === active)
            return;
        active = next;
        onChange(next);
    };
    const observer = typeof IntersectionObserver === "undefined"
        ? null
        : new IntersectionObserver((entries) => {
            inView = entries[entries.length - 1]?.isIntersecting ?? true;
            sync();
        });
    observer?.observe(el);
    const onVisibility = () => {
        pageVisible = document.visibilityState === "visible";
        sync();
    };
    document.addEventListener("visibilitychange", onVisibility);
    return () => {
        observer?.disconnect();
        document.removeEventListener("visibilitychange", onVisibility);
    };
};
export const useInView = (ref, onChange) => {
    const activeRef = useRef(true);
    const onChangeRef = useRef(onChange);
    useEffect(() => {
        onChangeRef.current = onChange;
    }, [onChange]);
    useEffect(() => {
        const el = ref.current;
        if (!el)
            return;
        const unobserve = observeActivity(el, (active) => {
            activeRef.current = active;
            onChangeRef.current?.(active);
        });
        return () => {
            unobserve();
            activeRef.current = true;
        };
    }, [ref]);
    return activeRef;
};
